import React from "react";

import { Navigate, Outlet } from "react-router-dom";

const ControlAuthRoutes = (props) => {
    const auth = localStorage.getItem('auth_name');
    return auth ? <Navigate to="/"/>: <Outlet/>
}
export default ControlAuthRoutes;